/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-12-24 16:45:28
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-06-19 14:32:36
 * @FilePath: /wemeet-web-activity/src/pages/questions/components/phone/index.tsx
 * @Description: 手机号
 */
import React, { memo, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import PhoneInput from "../../../PayEnd/component/phoneInput/inputZone";
import { Input, Button, Form, message } from '@tencent/tea-component';
import ActivitiesNotifySendVerificationCode from "../../../quickServices/ActivitiesNotifySendVerificationCode";
import { Validator } from "../../../PayEnd/component/phoneInput/validator";
import classnames from 'classnames';
import useCaptcha from "../../hooks/useCaptcha";
import { validatePhone } from "../../utils/validateForm";
import { ThemeContext } from "../../../BuyModal/context";
const Phone = ({
  value = '',
  onChange,
  userPhone,
  required,
  isMobile,
  list,
  openCheck,
  http: remoteHttp
}) => {
  const themeContext = useContext(ThemeContext);
  const http = remoteHttp || themeContext.http;
  const initPhone = useMemo(() => value.split(';')?.[1], []);
  const [phone, setPhone] = useState(initPhone);
  // const [hasChange, setHasChange] = useState(false);
  const [isErrPhone, setIsErrPhone] = useState(false);
  const [sendingSms, setSendingSms] = useState(false);
  const [isErrSms, setIsErrSms] = useState(false);
  const [smsCode, setSmsCode] = useState('');
  const [area, setArea] = useState('86');
  const genCaptcha = useCaptcha();
  const [captchTime, setCaptchTime] = useState(0);
  const isPhone = useMemo(() => Validator.isPhone(phone), [phone]);
  useEffect(() => {
    // 避免同时修改
    // if (!hasChange && userPhone && !phone) {
    //   changePhone(userPhone);
    //   return;
    // }

    if (value && !phone) {
      // 兼容空格情况
      const tag = value.indexOf(';') > -1 ? ';' : ' ';
      const nPhone = value.split(tag)?.[1];
      changePhone(nPhone);
    }
  }, [value, phone, list]);
  const changeArea = val => {
    // setShowSms(val === '86');
    setArea(val);
    onChange?.({
      phone,
      area: val,
      sms: smsCode
    });
  };
  const changePhone = val => {
    // setHasChange(true);
    // 手机号校验
    setPhone(val);
    onChange?.({
      phone: val,
      area,
      sms: smsCode
    });
    if (isErrPhone && Validator.isPhone(val)) {
      setIsErrPhone(false);
    }
  };
  const canSendSms = useMemo(() => Validator.isPhone(phone), [phone]);

  // 手机号失去焦点处理
  const blurValidatePhone = useCallback(() => {
    setIsErrPhone(!validatePhone(`${area};${phone}`));
  }, [phone, area]);

  // 验证码失去焦点处理
  const blurValidateSms = useCallback(() => {
    setIsErrSms(!Validator.isSmsCode(smsCode));
  }, [smsCode]);
  const sendSmsCode = useCallback(() => {
    if (sendingSms) {
      return;
    }
    setSendingSms(true);
    genCaptcha().then(res => {
      if (res.ret === 0) {
        ActivitiesNotifySendVerificationCode({
          phone,
          scene: 1,
          area
        }, http).then(resData => {
          setSendingSms(false);
          if (resData.code === 0) {
            const resetTime = time => {
              setCaptchTime(time);
              setTimeout(() => {
                if (time > 0) {
                  resetTime(time - 1);
                  return;
                }
              }, 1000);
            };
            resetTime(59);
          } else {
            message.error({
              content: resData?.msg || '网络异常，请稍后重试'
            });
          }
        }).catch(() => {
          message.error({
            content: '网络异常，请重试'
          });
          setSendingSms(false);
        });
      }
    }, () => {
      setSendingSms(false);
    });
  }, [sendingSms, phone, area]);
  return /*#__PURE__*/React.createElement("div", {
    className: "event-question-item-phone-zone"
  }, /*#__PURE__*/React.createElement(Form.Item, {
    className: "event-question-item-phone",
    status: isErrPhone ? 'error' : undefined,
    showStatusIcon: false,
    label: "\u624B\u673A\u53F7",
    required: required,
    message: isErrPhone ? '请输入正确的手机号' : ''
  }, /*#__PURE__*/React.createElement(PhoneInput, {
    showBorder: !isMobile,
    changeArea: changeArea,
    onChange: changePhone,
    onBlur: blurValidatePhone,
    error: isErrPhone,
    autoFocus: false,
    value: phone,
    className: "question-phone-input"
  })), area === '86' && isPhone && openCheck === 1 && phone !== userPhone && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "event-questions-form-sms"
  }, /*#__PURE__*/React.createElement(Form.Item, {
    className: "event-question-item-phone event-questions-form-sms-input",
    status: isErrSms ? 'error' : undefined,
    showStatusIcon: false
  }, /*#__PURE__*/React.createElement(Input, {
    onChange: val => {
      setSmsCode(val);
      onChange?.({
        phone,
        area,
        sms: val
      });
      if (isErrSms && Validator.isSmsCode(val)) {
        setIsErrSms(false);
      }
    },
    className: classnames({
      'no-border': isMobile
    }),
    type: "tel",
    value: smsCode
    // @ts-ignore
    ,
    autocomplete: "one-time-code",
    onBlur: blurValidateSms,
    size: "full",
    placeholder: "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801"
  })), /*#__PURE__*/React.createElement(Button, {
    className: classnames({
      'event-questions-form-sms-btn': true
    }),
    type: "weak",
    disabled: !canSendSms || captchTime > 0,
    loading: sendingSms,
    onClick: sendSmsCode
  }, captchTime <= 0 ? '获取验证码' : `${captchTime}s后重新获取`)), isErrSms && /*#__PURE__*/React.createElement("div", {
    className: "event-questions-form-error"
  }, "\u8BF7\u586B\u4E0B\u6B63\u786E\u7684\u9A8C\u8BC1\u7801")));
};
export default /*#__PURE__*/memo(Phone);